import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { ListItemText, MenuItem } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import {
  CheckAllRoles,
  CheckRoleForClient,
  CheckAllRights,
  CheckRightsForClient,
  CheckCrmUserManagementRoleForClient,
  CheckCrmAccessForClient,
} from "../../../Helpers/PermissionsChecks";
import { useSelector } from "react-redux";
import { selectUserPermissionsValue } from "../../../State/Slices/UserPermissionsSlice";
import { selectClientValue } from "../../../State/Slices/SelectedClientSlice";
import { RouteTypes } from "../../../Enums/RouteTypes";
import { MenuCategory } from "../../../Enums/MenuCategory";
import theme from "../../../../theme";

const useStyles = makeStyles({
  linkText: {
    color: "black",
    textDecoration: "none",
  },
  item: {
    margin: "20px 0px 0px 0px",
    justifyContent: "flex-start",
    display: "flex",
    width: "220px",
  },
  disabledItem: {
    margin: "20px 0px 0px 0px",
    justifyContent: "flex-start",
    display: "flex",
    width: "220px",
    pointerEvents: "none",
    opacity: "0.5",
  },
  itemText: {
    paddingRight: "20px",
    color: theme.palette.primary.copy,
  },
});

function checkRouteAccess(
  rolesObject,
  baseClientId,
  routeType,
  requiredPermissions
) {
  switch (routeType) {
    case RouteTypes.Unprotected:
      return true;
    case RouteTypes.RoleProtected:
      return CheckAllRoles(rolesObject, requiredPermissions);
    case RouteTypes.ClientRoleProtected:
      return CheckRoleForClient(rolesObject, baseClientId, requiredPermissions);
    case RouteTypes.RightProtected:
      return CheckAllRights(rolesObject, requiredPermissions);
    case RouteTypes.ClientRightProtected:
      return CheckRightsForClient(
        rolesObject,
        baseClientId,
        requiredPermissions
      );
    case RouteTypes.ClientCrmRightsProtected:
      return (
        CheckCrmUserManagementRoleForClient(rolesObject, baseClientId) ||
        CheckRightsForClient(rolesObject, baseClientId, requiredPermissions)
      );
    case RouteTypes.ClientCrmAccessRightsProtected:
      return CheckCrmAccessForClient(rolesObject, baseClientId);
    default:
      return false;
  }
}

function checkMenuIndex(navMenuSelection, menuCategory) {
  if (navMenuSelection === menuCategory) {
    return true;
  }
  return false;
}

export default function SubMenuItem(props) {
  const classes = useStyles();
  const rolesObject = useSelector(selectUserPermissionsValue);
  const selectedClient = useSelector(selectClientValue);

  const [hasRouteAccess, setHasRouteAccess] = useState(false);
  const [visibleInMenu, setVisibleInMenu] = useState(false);

  const currentRoute = useLocation().pathname;

  useEffect(() => {
    setVisibleInMenu(
      checkMenuIndex(props.navMenuSelection, props.menuCategory)
    );
    setHasRouteAccess(
      checkRouteAccess(
        rolesObject,
        selectedClient.id?.toUpperCase(),
        props.routeType,
        props.requiredPermissions
      )
    );
  }, [
    props.navMenuSelection,
    props.menuCategory,
    rolesObject,
    selectedClient,
    props.routeType,
    props.requiredPermissions,
  ]);

  if (visibleInMenu === true) {
    if (hasRouteAccess === true) {
      if (props.menuCategory === MenuCategory.MoreApps) {
        return (
          <NavLink
            className={classes.linkText}
            to={{ pathname: props.route }}
            target="_blank"
          >
            <MenuItem
              onClick={props.clickEvent}
              className={classes.item}
              selected={currentRoute === props.route}
              sx={{
                minWidth: "95px",
                "&.Mui-selected": {
                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                  },
                },
              }}
            >
              <ListItemText className={classes.itemText}>
                {props.title}
              </ListItemText>
            </MenuItem>
          </NavLink>
        );
      } else {
        return (
          <NavLink className={classes.linkText} to={props.route}>
            <MenuItem
              onClick={props.clickEvent}
              className={classes.item}
              selected={currentRoute === props.route}
              sx={{
                minWidth: "95px",
                "&.Mui-selected": {
                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                  },
                },
              }}
            >
              <ListItemText sx={{ padding: "6px" }}>{props.title}</ListItemText>
            </MenuItem>
          </NavLink>
        );
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}
